import React from 'react';
import { Users, Building2, Calendar, UsersRound, Vote, Users2, Shield, Sparkles, Heart } from 'lucide-react';

const Nucleos = () => {
    const guidelines = [
        {
            icon: <Users className="w-4 h-4" />,
            title: "Congregação dos Graduados",
            description: "Deverão congregar todos os graduados da Faculdade, podendo haver Núcleos a nível dos Departamentos e/ou Secções."
        },
        {
            icon: <Calendar className="w-4 h-4" />,
            title: "Plano de Actividades",
            description: "Devem conceber um plano de actividades a realizar para garantir a participação activa dos membros."
        },
        {
            icon: <Vote className="w-4 h-4" />,
            title: "Selecção de Representantes",
            description: "A selecção dos representantes do Núcleo poderá ser realizada a partir de sufrágio ou outro mecanismo, conduzido pela Faculdade ou Escola Superior."
        },
        {
            icon: <Shield className="w-4 h-4" />,
            title: "Tomada de Posse",
            description: "O processo de tomada de posse e exercício de funções dos representantes será sempre conduzido pela Faculdade / Escola Superior."
        },
        {
            icon: <Users2 className="w-4 h-4" />,
            title: "Assembleia Geral",
            description: "Os Representantes dos Núcleos devem ser reunidos na Assembleia Geral da Comunidade Alumni para subsidiar a representação nos órgãos colegiados."
        }
    ];

    return (
        <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
            {/* Header Section */}
            <div className="mb-12">
                <div className="border-l-4 border-emerald-500 pl-4 mb-4">
                    <h1 className="text-3xl font-light text-gray-800 tracking-tight">Núcleos Alumni</h1>
                    <p className="text-gray-500 text-base font-light mt-1">
                        Representação dos graduados nas Faculdades e Escolas da UEM
                    </p>
                </div>
            </div>

            {/* Introduction */}
            <div className="mb-10">
                <p className="text-gray-600 leading-relaxed">
                    A Comunidade Alumni da UEM deve estar devidamente representada nas Faculdades / Escolas Superiores, 
                    bem como nos órgãos colegiais. Esse processo de formalização é realizado a partir das
                    Faculdades / Escolas Superiores, nas quais os graduados se reúnem em forma de 
                    <span className="font-medium text-emerald-600"> Núcleos</span>, exactamente para representar o seu grupo de graduados.
                </p>
            </div>

            {/* Guidelines Section */}
            <div className="mb-10">
                <div className="flex items-center gap-2 mb-6">
                    <Building2 className="w-5 h-5 text-emerald-500" />
                    <h2 className="text-lg font-medium text-gray-700">Directrizes dos Núcleos</h2>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {guidelines.map((guideline, index) => (
                        <div 
                            key={index}
                            className="bg-white rounded-xl border border-gray-100 p-5 hover:shadow-md transition-all duration-300 group"
                        >
                            <div className="flex gap-3">
                                <div className="flex-shrink-0">
                                    <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
                                        <div className="text-emerald-500">
                                            {guideline.icon}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-700 mb-1">
                                        {guideline.title}
                                    </h3>
                                    <p className="text-gray-500 text-xs leading-relaxed">
                                        {guideline.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Additional Info Section */}
            <div className="bg-gradient-to-r from-emerald-50/30 to-gray-50/30 rounded-xl p-6 border border-emerald-100/30 mb-10">
                <div className="flex gap-4">
                    <div className="flex-shrink-0">
                        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                            <UsersRound className="w-5 h-5 text-emerald-600" />
                        </div>
                    </div>
                    <div>
                        <h3 className="text-base font-medium text-gray-700 mb-2">
                            Importância dos Núcleos
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed">
                            Os Núcleos Alumni são fundamentais para manter a ligação entre os graduados e a instituição, 
                            promovendo a participação activa nos processos decisórios e contribuindo para o 
                            desenvolvimento contínuo da Universidade Eduardo Mondlane.
                        </p>
                    </div>
                </div>
            </div>

            {/* Stats Section */}
            <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-xl p-6">
                <div className="flex justify-around items-center">
                    <div className="text-center">
                        <div className="text-2xl font-light text-white mb-1">10+</div>
                        <div className="text-xs text-emerald-100">Faculdades</div>
                    </div>
                    <div className="w-px h-8 bg-emerald-500/50"></div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-white mb-1">Em Formação</div>
                        <div className="text-xs text-emerald-100">Núcleos Activos</div>
                    </div>
                    <div className="w-px h-8 bg-emerald-500/50"></div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-white mb-1">Anual</div>
                        <div className="text-xs text-emerald-100">Assembleia Geral</div>
                    </div>
                </div>
            </div>

            {/* Footer Note */}
            <div className="mt-8 text-center">
                <p className="text-xs text-gray-400">
                    Os Núcleos Alumni representam a voz dos graduados nos órgãos colegiais da Universidade
                </p>
            </div>
        </div>
    );
};

export default Nucleos;